import {Alert, Breadcrumb, Button, Divider, Input, Layout, Modal, notification, theme} from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  apiCreateSplitPlan,
  apiDeleteSplitPlan,
  apiDetailsSplitPlans,
  apiUpdateSplitPlan,
  deleteSplitPlan
} from "../../../api/splitPlans";
import { apiDetailsZoopPlan } from "../../../api/zoopPlan";
import SplitDetailsTable from "./SplitDetailsTable/SplitDetailsTable";
import "./SplitPlanDetails.scss";
const SplitPlanDetails = ({ copy }) => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const navigate = useNavigate();
  const pathname = window.location.pathname;
  const parts = pathname.split("/");
  const id = parts[parts.length - 1];
  const [dataTransaction, setDataTransaction] = useState();
  const [name, setName] = useState();
  const [plan, setPlan] = useState();
  const [description, setDescription] = useState();
  const [dataZoop, setDataZoop] = useState();
  const [enableEdit, setEnableEdit] = useState(copy);
  const [splitDetails, setSplitDetails] = useState();
  const [splitDetailsOnline, setSplitDetailsOnline] = useState();
  const [splitDetailsOthers, setSplitDetailsOthers] = useState();
  const [loading, setLoading] = useState(false);

  const isSplitPlanEmpty = (details, detailsOnline) => {
    const parseDetails = (value) => {
      try {
        return JSON.parse(value?.replaceAll("'", "\""));
      } catch (error) {
        return null;
      }
    };
    const physical = parseDetails(details);
    const online = parseDetails(detailsOnline);
    if (!physical || typeof physical !== "object" || Array.isArray(physical)) {
      return false;
    }
    if (!online || typeof online !== "object" || Array.isArray(online)) {
      return false;
    }
    return Object.keys(physical).length === 0 && Object.keys(online).length === 0;
  }

  const compileSplitDetails = () => {
    let physical = JSON.parse(splitDetails?.replaceAll("'", "\""));
    let others = JSON.parse(splitDetailsOthers?.replaceAll("'", "\""));

    // compile pix
    if (others['debit'] && others['debit']['1'] && others['debit']['1']['PIX']) {
      physical['debit'] = physical['debit'] || {};
      physical['debit']['1'] = physical['debit']['1'] || {};
      physical['debit']['1']['PIX'] = others['debit']['1']['PIX'];
    }
    if (others['debit'] && others['debit']['1'] && others['debit']['1']['Boleto']) {
      physical['debit'] = physical['debit'] || {};
      physical['debit']['1'] = physical['debit']['1'] || {};
      physical['debit']['1']['Boleto'] = others['debit']['1']['Boleto'];
    }
    return JSON.stringify(physical);
  }

  const handleSubmit = () => {
    setLoading(true)
    if (copy) {
      apiCreateSplitPlan({
        name: name,
        split_details: compileSplitDetails().replaceAll("\"", "'"),
        split_details_online: splitDetailsOnline?.replaceAll("\"", "'"),
        zoop_tax_plan: dataZoop.id
      }).then(response => response.json())
      .then((json) => {
        notification.success({
          message: "Sucesso!",
          description: "Plano criado com sucesso!",
        });
        setEnableEdit(false)
        setLoading(false)
        navigate(`/planos-e-taxas/detalhe/${json.id}`)
      }).catch((error) => {
        notification.error({
          message: "Erro",
          description: "Ocorreu um erro ao criar o plano. Contate um administrador.",
        });
        setLoading(false)
      })
    } else {
      apiUpdateSplitPlan(id, {
        name: name,
        split_details: compileSplitDetails().replaceAll("\"", "'"),
        split_details_online: splitDetailsOnline?.replaceAll("\"", "'")
      }).then((json) => {
        notification.success({
          message: "Sucesso!",
          description: "Plano atualizado com sucesso!",
        });
        setEnableEdit(false)
        setLoading(false)
      }).catch((error) => {
        notification.error({
          message: "Erro",
          description: "Ocorreu um erro ao atualizar o plano. Contate um administrador.",
        });
        setLoading(false)
      })
    }
  }

  useEffect(() => {
    if (id) {
      apiDetailsSplitPlans(id).then((json) => {
        setDataTransaction(json)
        setName(json.name + (copy ? ' (Cópia)' : ''))
        setPlan(json.zoop_tax_plan.name)
        setDescription(json.zoop_tax_plan.description)
        setSplitDetails(json?.split_details)
        setSplitDetailsOthers(structuredClone(json?.split_details))
        setSplitDetailsOnline(json?.split_details_online)

        apiDetailsZoopPlan(json.zoop_tax_plan.id).then((zoop) => {
          setDataZoop(zoop)
        })
      })
    }
  }, []);

  const handleDuplicate = () => {
    Modal.confirm({
      title: 'Confirmar duplicação',
      content: `Ao prosseguir, você confirma que quer criar uma cópia do plano (${name}). Deseja prosseguir?`,
      okText: 'Sim, duplicar',
      cancelText: 'Não, cancelar',
      onOk() {
        setEnableEdit(true);
        window.location.href = `/planos-e-taxas/duplicar/${id}`;
      },
    });
  }

  return (
    <div className="SplitPlanDetails">
      <Layout
        style={{
          padding: "1.25rem",
        }}
      >
        <Breadcrumb
          style={{
            margin: "16px 0",
          }}
        >
          <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <h2 className="title-page">{name}</h2>
             <div style={{display: 'flex', gap: '10px'}}>
               {copy && <div className={"error"}>Aviso! Esta cópia ainda não foi salva!</div>}
               {!copy && <Button onClick={() => setEnableEdit(!enableEdit)} type={`${enableEdit ? 'primary' : ''}`}>Editar</Button>}
               {!copy && <Button onClick={() => handleDuplicate()}>Duplicar</Button>}
             </div>
          </div>
          <Divider />
          <Breadcrumb.Item>Planos e Taxas</Breadcrumb.Item>
          <Breadcrumb.Item>{name}</Breadcrumb.Item>
        </Breadcrumb>
        <Content
          style={{
            padding: 24,
            margin: "30px 0 0 0",
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <div className="container-subtitle">
            <h3 className="subtitle-page">1. Propriedades gerais</h3>
          </div>
          <Divider />
          <div className="container-inputs">
            <div>
              <p>Nome</p>
              <Input
                disabled={!enableEdit}
                onChange={(e) => setName(e.target.value)}
                value={name}
              />
            </div>
            <div className="container-two">
              <div>
                <p>PLANO</p>
                <Input
                  disabled
                  value={plan}
                />
              </div>
              <div>
                <p>Descrição</p>
                <Input
                  disabled
                  value={description}
                />
              </div>
            </div>
          </div>
          {dataTransaction?.automatic_developer_fee === false && (
            <Alert
              style={{ marginTop: 16 }}
              message="Este plano não possui taxa automática da plataforma. Defina a taxa manualmente em cada opção das tabelas."
              type="warning"
              showIcon
            />
          )}
          {isSplitPlanEmpty(dataTransaction?.split_details, dataTransaction?.split_details_online) && (
            <Alert
              style={{ marginTop: 16 }}
              message="Este plano ainda não possui divisões configuradas. Enquanto estiver assim, nenhum recebedor será pago nas transações que o utilizarem."
              type="warning"
              showIcon
            />
          )}
        </Content>

                <Content
          style={{
            padding: 24,
            margin: '30px 0 0 0',
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <div className="container-subtitle">
            <h3 className="subtitle-page">2. Boleto & Pix</h3>
          </div>
          <Divider />

          {dataTransaction && dataZoop && <SplitDetailsTable
            splitDetails={splitDetailsOthers}
            setSplitDetails={setSplitDetailsOthers}
            zoopPlans={dataZoop}
            enableEdit={enableEdit}
            mode={'others'}
          />}
        </Content>

        <Content
          style={{
            padding: 24,
            margin: '30px 0 0 0',
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <div className="container-subtitle">
            <h3 className="subtitle-page">3. Vendas Presenciais</h3>
          </div>
          <Divider />

          {dataTransaction && dataZoop && <SplitDetailsTable
            splitDetails={splitDetails}
            setSplitDetails={setSplitDetails}
            zoopPlans={dataZoop}
            enableEdit={enableEdit}
            mode={'physical'}
          />}
        </Content>

        <Content
          style={{
            padding: 24,
            margin: '30px 0 0 0',
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <div className="container-subtitle">
            <h3 className="subtitle-page">4. Vendas Online</h3>
          </div>
          <Divider />

          {dataTransaction && dataZoop && <SplitDetailsTable
            splitDetails={splitDetailsOnline}
            setSplitDetails={setSplitDetailsOnline}
            zoopPlans={dataZoop}
            enableEdit={enableEdit}
            mode={'online'}
          />}
        </Content>


        <div className="container-buttons" style={{ marginTop: "30px", display: 'flex', justifyContent: 'end', width: '100%' }}>
          {!copy && enableEdit && <Button loading={loading} onClick={() => handleSubmit()} type="primary">Salvar alterações</Button>}
          {copy && <Button loading={loading} onClick={() => handleSubmit()} type="primary">Criar plano</Button>}
        </div>
      </Layout>
    </div >
  );
};

export default SplitPlanDetails;
